import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import useTableColumn from '../../../../../customHooks/useTableColumn';
import useGetQueryParams from '../../../../../customHooks/useGetQueryParams';
import AdminTable from '../../../../../components/AdminTable';
import EmptyRecord from '../../../../../components/EmptyRecord';
import useCustomQuery from '../../../../../network/useCustomQuery';
import { GET_USER_CA_WALLET_TRANSACTIONS } from '../../../../../graphql/admin_queries';
import { cleanUpUserCaTransactionsRec } from '../../../../../utils/helpers';

import { IWalletDetailsRecords } from './WalletDetailsRecord.types';
import { allColumns, columnLabelFormat, limit } from './WalletDetailsRecord.data';

import EmptyMerchantSettlement from '../../../../../svgs/EmptyMerchantSettlement';

const WalletDetailsRecords = ({
  toggleStorageId,
  defaultUrl,
  userId,
}:IWalletDetailsRecords) => {
  const [userCaWalletTransactionsRec, setUserCaWalletTransactionsRec] = useState(null);
  const { push } = useHistory();
  const setPage = (pageNum) => {
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set('page', pageNum);
    push({
      search: searchParams.toString(),
    });
  };

  const { getQuery, getFilterQueries } = useGetQueryParams();
  const page = Number(getQuery('page'));
  const { getColumns } = useTableColumn(allColumns, toggleStorageId);
  if (!page) {
    push(`${defaultUrl}?page=1`);
  }

  const [
    getUserCaWalletTransactions,
    userCaWalletTransactionsLoading,
    userCaWalletTransactions,
  ] = useCustomQuery({
    query: GET_USER_CA_WALLET_TRANSACTIONS,
    onError: () => {},
    onData: () => {},
  });

  useEffect(() => {
    if (page) {
      const result = getFilterQueries();
      getUserCaWalletTransactions({
        variables: {
          userId,
          offset: (page - 1) * limit,
          limit,
          filters: {
            from: result.from,
            to: result.to,
            channel: result?.channel,
            status: result?.status,
          },
        },
      });
    }
  }, [page]);

  useEffect(() => {
    if (userCaWalletTransactions?.getUserCaWalletTransactions) {
      setUserCaWalletTransactionsRec(userCaWalletTransactions?.getUserCaWalletTransactions?.data);
    }
  }, [userCaWalletTransactions]);

  return (
    <div className="settlement-table-details-cover customer-repayment-cover">
      {userCaWalletTransactionsRec?.count ? (
        <AdminTable
          refreshing={userCaWalletTransactionsLoading}
          page={page}
          setPage={setPage}
          pageSize={limit}
          minHeight="calc(100vh - 280px)"
          count={userCaWalletTransactionsRec?.count}
          contents={cleanUpUserCaTransactionsRec(userCaWalletTransactionsRec?.transactions)}
          reference="id"
          hideDominantImage
          allowKeyArr={getColumns(true)}
          mobileAllowKeyArr={
            [
              'status',
              ['transactions', 'amount'],
              ['', 'date'],
            ]
          }
          formatLabels={columnLabelFormat}
        />
      ) : (
        <EmptyRecord
          height="400px"
          title={userCaWalletTransactionsLoading ? 'Fetching wallet records...' : 'No Records yet'}
          main="Customer has no wallet records."
          loading={userCaWalletTransactionsLoading}
          Icon={EmptyMerchantSettlement}
        />
      )}
    </div>
  );
};
export default WalletDetailsRecords;
